import { createBrowserRouter } from "react-router-dom"
import App from "../App"
import Home from "../pages/Home/Home";
import Login from "../pages/Login/Login";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import Signup from "../pages/Signup/Signup";
import Admin from "../pages/AdminPanel/Admin";
import AllUsers from "../pages/AdminPanel/AllUsers";
import AllProducts from "../pages/AdminPanel/AllProducts";
import CategoryProduct from "../pages/CategoryProducts/CategoryProduct";
import ProductDetails from "../pages/ProductDetails/ProductDetails";
import Cart from "../pages/Cart/Cart";
import SearchProducts from "../pages/SearchProducts/SearchProducts";
import Checkout from "../pages/Checkout/Checkout";
import UserOrder from "../pages/Order/UserOrder";
import StripeVerify from "../pages/VerifyPayment/StripeVerify";
import FlutterVerify from "../pages/VerifyPayment/FlutterVerify";
import UserProfile from "../components/UserProfile/UserProfile";
import ProfileModal from "../components/UserProfileModal/UserProfileModal";
import OrderInventory from "../pages/AdminPanel/OrderInventory";
import NewsletterAdmin from "../pages/AdminPanel/NewsletterAdmin";
import UnsubscribeForm from "../components/UnSubNewsletterBox/UnsubscribeForm";
import LiveChat from "../components/ChatMessageAssistant/LiveChat";
import Dashboard from "pages/AdminPanel/Dashboard";
import LikedProducts from "../pages/LikedProducts/LikedProducts";
import NotificationsPage from "../pages/Notifications/NotificationsPage";
import LandingPage from "pages/Home/LandingPage";
import MyTradeIns from "pages/TradeIn/MyTradeIns";
import SubmitTradeIn from "pages/TradeIn/SubmitTradeIn";
import AdminTradeIns from "pages/AdminPanel/AdminTradeIns";
import AdminRefurbishedPhones from "pages/AdminPanel/AdminRefurbishedPhones";
import RefurbishedPhonesList from "components/RefurbishedPhones/RefurbishedPhonesList";
import RefurbishedPhoneDetails from "components/RefurbishedPhones/RefurbishedPhoneDetails";
// import PurchaseGiftCard from "../components/GiftCard/PurchaseGiftCard";
import { MyGiftCardsPage } from "components/GiftCard/MyGiftCardsPage";

import { AdminGiftCardsDashboard } from "pages/AdminPanel/AdminGiftCard/AdminGiftCardsDashboard";
import { CheckBalancePage } from "components/GiftCard/CheckBalancePage";
import { CheckoutWithGiftCard } from "components/GiftCard/CheckoutWithGiftCard";
import { PurchaseGiftCard } from "components/GiftCard/PurchaseGiftCard";
import { ReceivedGiftCardsPage } from "components/GiftCard/RecievedGiftCardsPage";
import ManageDeals from "pages/AdminPanel/AdminDeal/ManageDeals";
import FlashDeals from "components/Deals/FlashDeals";
import About from "pages/Home/About";
import Contact from "pages/Home/Contact";
import AdminLogo from "pages/AdminPanel/AdminLogo";
import BannerManager from "pages/AdminPanel/BannerManager";
import GiftCardPaymentVerify from "pages/VerifyPayment/GiftCardPaymentVerify";
import AdminRepairDashboard from "pages/AdminPanel/AdminRepairDashboard";
import RepairRequestForm from "pages/Repairs/RepairRequestForm";
import UserRepairRequests from "pages/Repairs/UserRepairRequests";
import Homes from "pages/Home/Homes";
import ProductsInCategories from "components/CategoryProductDisplay/ProductsInCategories";


const router = createBrowserRouter([
    {
        path: "/",
        element: <App/>,
        children: [
            {
                 path: "/",
                 element: <Home/> 
            },
            {
                 path: "landing",
                 element: <LandingPage/> 
            },
            {
                 path: "homes",
                 element: <Homes/> 
            },
            {
                path: "login",
                element: <Login/>
            },
            {
                path: "profile",
                element: <UserProfile/>
            },
            {
                path: "profilemodal",
                element: <ProfileModal/>
            },
            {
                path: "forgot-password",
                element: <ForgotPassword/>
            },
            {
                path: "register",
                element: <Signup/>
            },
            {
                path: "product-category",
                element: <CategoryProduct/>
            },
            {
                path: "category/:category",  // ✅ ADD THIS NEW ROUTE
                element: <ProductsInCategories/>
            },
            {
                path: "product/:id",
                element: <ProductDetails/>
            },
            {
                path: 'cart',
                element: <Cart/>
            },
            {
                path: "checkout",
                element: <Checkout/>
            },
            {
                path: 'search',
                element: <SearchProducts/>
            },            
            {
                path: "orders",
                element: <UserOrder/>
            },
            {
                path: '/verify',
                element: <StripeVerify />
            },
            {
                path: '/flwverify',
                element: <FlutterVerify/>
            },
            {
                path: '/giftcard-payment-verify',
                element: <GiftCardPaymentVerify/>
            },
            {
                path: "unsubscribe",
                element: <UnsubscribeForm/>
            },
            {
                path: "livechat",
                element: <LiveChat/>
            },
            {
                path: "liked-products",
                element: <LikedProducts/>
            },
            {
                path: "notifications",
                element: <NotificationsPage/>
            },
            {
                path: "my-tradeins",
                element: <MyTradeIns/>
            },
            {
                path: "submit-tradein",
                element: <SubmitTradeIn/>
            },
            {
                path: "refurbished",
                element: <RefurbishedPhonesList/>
            },
            {
                path: "refurbished/:phoneId",
                element: <RefurbishedPhoneDetails/>
            },
            {
                path: "purchase-giftcard",
                element: <PurchaseGiftCard/>
            },
            {
                path: "my-giftcards",
                element: <MyGiftCardsPage/>
            },
            {
                path: "received-giftcards",
                element: <ReceivedGiftCardsPage/>
            },
            {
                path: "check-giftcard-balance",
                element: <CheckBalancePage/>
            },
            {
                path: "giftcard/checkout",
                element: <CheckoutWithGiftCard/>
            },
            {
                path: "flashdeals",
                element: <FlashDeals/>
            },
            {
                path: "repair-requests",
                element: <RepairRequestForm/>
            },
            {
                path: "repair-lists",
                element: <UserRepairRequests/>
            },
            {
                path: "about",
                element: <About/>
            },
            {
                path: "contact",
                element: <Contact/>
            },
            {
                path: "admin",
                element: <Admin/>,
                children: [
                    {
                        path: "dashboard",
                        element: <Dashboard/>
                    },
                    {
                        path: "all-users",
                        element: <AllUsers/>
                    },
                    {
                        path: "all-products",
                        element: <AllProducts/>
                    },
                    {
                        path: "order-inventory",
                        element: <OrderInventory/>
                    },
                    {
                        path: "newsletter-admin",
                        element: <NewsletterAdmin/>
                    },
                    {
                        path: "admin-tradeins",
                        element: <AdminTradeIns/>
                    },
                    {
                        path: "admin-refurbished-phones",
                        element: <AdminRefurbishedPhones/>
                    },
                    {
                        path: "admin-giftcards",
                        element: <AdminGiftCardsDashboard/>
                    },
                    {
                        path: "admin-deals",
                        element: <ManageDeals/>
                    },
                    {
                        path: "admin-logo",
                        element: <AdminLogo/>
                    },
                    {
                        path: "admin-banner",
                        element: <BannerManager/>
                    },
                    {
                        path: "admin-repair",
                        element: <AdminRepairDashboard/>
                    }
                ]
            }
        ]
    }
])

export default router;